const state = {
    chartConfiguration: {},
    dashboardCard: [],
    currentConfigureCardType: null,
};

const mutations = {
    SET_CHART_CONFIGURATION: (state, info) => {
        state.chartConfiguration = info;
    },
    SET_DASHBOARD_CARD: (state, info) => {
        state.dashboardCard = info;
    },
    SET_CURRENT_CONFIGURE_CARD_TYPE: (state, info) => {
        console.log("currentConfigureCardType", info);
        state.currentConfigureCardType = info;
    },
};

const actions = {
    setChartConfiguration({ commit }, info) {
        commit("SET_CHART_CONFIGURATION", info);
    },
    setDashboardCard({ commit }, info) {
        commit("SET_DASHBOARD_CARD", info);
    },
    setCurrentConfigureCardType({ commit }, info) {
        commit("SET_CURRENT_CONFIGURE_CARD_TYPE", info);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/vuex/modules/personalize_dashboard.js